import initI18n from './i18n';
import { registerMcpServerIconResolver } from '@erikdakoda/ai-tool/shared/getToolIcon';
import { registerToolCallContextEnricher } from '@erikdakoda/ai-tool/shared/toolCallContextEnrichers';
import { getMcpServerIcon } from './shared/getMcpServerIcon';
import { mcpServerManagerToolCallEnrichers } from './toolCallEnrichers';

export default function init(): void {
  initI18n();
  registerMcpServerIconResolver((serverName, override) => getMcpServerIcon(serverName, override));
  for (const [toolKey, enricher] of Object.entries(mcpServerManagerToolCallEnrichers)) {
    registerToolCallContextEnricher(toolKey, enricher);
  }
}
